@if (formGroup) {
  <div class="form-container" [formGroup]="formGroup">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Name </label>
          </div>
          <clickatell-form-validation [controlName]="'name'"
          [form]="formGroup"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="formGroup" id="name"
            [formControlName]="'name'" placeholder="Enter name"/>
          </div>
          @if (chatDeskIntegrations$ | async; as integrations) {
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Sandbox Integration </label>
              </div>
              <clickatell-form-validation [controlName]="'sandboxIntegration'"
              [form]="formGroup"></clickatell-form-validation>
              <mat-select class="control-dropdown" [formControlName]="'sandboxIntegration'"
                placeholder="Select Sandbox Integration">
                @for (option of integrations.sandbox; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                }
              </mat-select>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Production Integration </label>
              </div>
              <clickatell-form-validation [controlName]="'productionIntegration'"
              [form]="formGroup"></clickatell-form-validation>
              <mat-select class="control-dropdown" [formControlName]="'productionIntegration'"
                placeholder="Select Production Integration">
                @for (option of integrations.production; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                }
              </mat-select>
            </div>
          } @else {
            <loading-icon></loading-icon>
          }
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Departments </label>
            </div>
            <mat-select class="control-dropdown" [formControlName]="'department'" placeholder="Select Department" hideSingleSelectionIndicator>
              <mat-option value="">
                Default
              </mat-option>
              @for (department of chatDeskDepartments$ | async; track department) {
                <mat-option [value]="department.id">
                  {{ department.name }}
                </mat-option>
              }
            </mat-select>
          </div>
        </ng-container>
      </clickatell-expansion-panel>
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <div class="control-result">
            <div class="control-result-header">
              Next
            </div>
            <div class="control-result-container">
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Description </label>
                </div>
                <clickatell-form-validation [controlName]="'nextDescription'"
                [form]="formGroup"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="formGroup" id="next"
                  [formControlName]="'nextDescription'" placeholder="Enter description"/>
                </div>
                <div class="control-div">
                  <label class="control-label">
                    <span class="pont-to">Point To</span>
                    <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                  </label>
                  @if (nodeFlowDetails) {
                    <next-selector [canEditFlows]="canEdit.canEditFlows"
                      [selectorType]="'both'"
                      [flowSteps]="nodeFlowDetails.currentFlowSteps"
                      [flows]="nodeFlowDetails.flows"
                      [name]="'next'"
                      [form]="formGroup"
                      [stepId]="nodeFlowDetails.stepId">
                    </next-selector>
                  }
                </div>
              </div>
            </div>
            <div class="control-result">
              <div class="control-result-header">
                Error
              </div>
              <div class="control-result-container">
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Description </label>
                  </div>
                  <clickatell-form-validation [controlName]="'errorDescription'"
                  [form]="formGroup"></clickatell-form-validation>
                  <input class="control-input" activeForm [activeForm]="formGroup" id="error"
                    [formControlName]="'errorDescription'" placeholder="Enter description"/>
                  </div>
                  <div class="control-div">
                    <label class="control-label">
                      <span class="pont-to">Point To</span>
                      <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                    </label>
                    @if (nodeFlowDetails) {
                      <next-selector [canEditFlows]="canEdit.canEditFlows"
                        [selectorType]="'both'"
                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                        [flows]="nodeFlowDetails.flows"
                        [name]="'error'"
                        [form]="formGroup"
                        [stepId]="nodeFlowDetails.stepId">
                      </next-selector>
                    }
                  </div>
                </div>
              </div>
            </ng-container>
          </clickatell-expansion-panel>
        </div>
      }